'use client';
import { Pagination } from './pagination.js';
import { PaginationButton } from './pagination-button.js';
import { PaginationItem } from './pagination-item.js';
import { PaginationList } from './pagination-list.js';

/**
 * Pagination component, used to navigate through a list of items.
 *
 * @example
 * <Pagination>
 *   <Pagination.List>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Forrige side'>Forrige</Pagination.Button>
 *     </Pagination.Item>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Side 1'>1</Pagination.Button>
 *     </Pagination.Item>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Side 2'>2</Pagination.Button>
 *     </Pagination.Item>
 *   </Pagination.List>
 * </Pagination>
 */
const PaginationComponent = Object.assign(Pagination, {
    List: PaginationList,
    Item: PaginationItem,
    Button: PaginationButton,
});
PaginationComponent.List.displayName = 'Pagination.List';
PaginationComponent.Item.displayName = 'Pagination.Item';
PaginationComponent.Button.displayName = 'Pagination.Button';

export { PaginationComponent as Pagination, PaginationButton, PaginationItem, PaginationList };
